<template>
    <el-select v-model="selectedOrganization" :placeholder="placeholder" @change="handleChange">
        <el-option v-if="isSearchModel" label="すべて" :value="ALL" />
        <el-option v-for="item in organizations" :key="item.organization_id" :label="item.name"
            :value="item.organization_id" />
    </el-select>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from 'vue';
import axios from 'axios';
import { ALL } from '@/config/constants';

export interface Organization {
    organization_id: string;
    name: string;
}

export default defineComponent({
    name: 'OrganizationSelect',
    props: {
        isSearch: {
            type: Boolean,
            default: false,
        },
        modelValue: {
            type: String,
            default: '',
        },
        placeholder: {
            type: String,
            default: '选择组织',
        },
    },

    emits: ['update:modelValue', 'change', 'organization-name-change'],

    setup(props, { emit }) {
        const organizations = ref<Organization[]>([]);
        const selectedOrganization = ref(props.modelValue);
        const isSearchModel = ref(props.isSearch);

        const fetchOrganizations = async () => {
            try {
                const response = await axios.get('/api/organizations/all');
                organizations.value = response.data.data;
                // 确保在获取数据后更新选中值
                if (props.modelValue && !selectedOrganization.value) {
                    selectedOrganization.value = props.modelValue;
                }
            } catch (error) {
                console.error('获取组织列表失败:', error);
            }
        };

        const handleChange = (value: string) => {
            emit('update:modelValue', value);
            emit('change', value);

            // 找到选中的组织对象
            const selectedOrganizationObj = organizations.value.find(
                org => org.organization_id === value
            );
            // 如果找到了组织对象，发送名称
            if (selectedOrganizationObj) {
                emit('organization-name-change', selectedOrganizationObj.name);
            }
        };

        onMounted(() => {
            fetchOrganizations();
        });

        watch(() => props.modelValue, (newValue) => {
            selectedOrganization.value = newValue;
        });

        return {
            organizations,
            selectedOrganization,
            handleChange,
            isSearchModel,
            ALL,
        };
    },
});
</script>